import { useLayoutEffect, useRef } from 'react';

// Keep loaded content mounted during refreshes so tables, expanded rows, focus,
// and the document height survive a save. The actual loading flag is unchanged
// and can still disable actions while fresh data is being fetched.
export function useInitialLoading(loading) {
  const state = useRef({ requested: false, completed: false });
  useLayoutEffect(() => {
    if (loading) state.current.requested = true;
    else if (state.current.requested) state.current.completed = true;
  }, [loading]);
  return loading && !state.current.completed;
}
